import { IDashboardTransaction } from "@/shared/api/onboarding"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"
import { Table } from "@/shared/ui/table"
import { ColumnDef } from "@tanstack/react-table"
import { ActionButton } from "@/shared/ui/action-button"
import ArrowLeftSvg from '@/shared/assets/images/ArrowBendDownRight.svg'
import { toLocaleString } from "@/shared/lib/to-locale-string"
import { parseTimestamp } from "@/shared/lib/parse-timestamp"
import { useNavigate } from "react-router-dom"

interface DashboardTransactionsTableProps {
    transactions: IDashboardTransaction[]
    isLoading: boolean
}

export const DashboardTransactionsTable = ({ transactions, isLoading }: DashboardTransactionsTableProps) => {
    const navigate = useNavigate()

    const columns: ColumnDef<IDashboardTransaction, any>[] = [
        {
            accessorFn: (transaction) => (
                <div>
                    {transaction.rrn ?? "—"}
                </div>
            ),
            id: 'rrn',
            cell: info => info.getValue(),
            enableSorting: false,
            header: () => <div className="!text-start text-nowrap">RRN</div>,
        },
        {
            accessorFn: (transaction) => (
                <div>
                    {transaction.isReturn ? 'Возврат' : 'Оплата'}
                </div>
            ),
            id: 'isReturn',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Тип операции</div>,
        },
        {
            accessorFn: (transaction) => {
                const { date } = parseTimestamp(transaction.timeStamp)
                return (
                    <div>
                        {date}
                    </div>
                )
            },
            id: 'date',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Дата операции</div>,
        },
        {
            accessorFn: (transaction) => {
                const { time } = parseTimestamp(transaction.timeStamp)
                return (
                    <div>
                        {time}
                    </div>
                )
            },
            id: 'time',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Время</div>,
        },
        {
            accessorFn: (transaction) => (
                <div>
                    {toLocaleString(transaction.discountTotal)}
                </div>
            ),
            id: 'discount',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Скидка, руб.</div>,
        },
        {
            accessorFn: (transaction) => (
                <div>
                    {toLocaleString(transaction.bonusTotal)}
                </div>
            ),
            id: 'bonus',
            cell: info => info.getValue(),
            enableSorting: false,
            header: () => <div className="!text-start text-nowrap">Скидка (Бонусы), руб.</div>,
        },
        {
            accessorFn: (transaction) => (
                <div>
                    {toLocaleString(transaction.taxTotal)}
                </div>
            ),
            id: 'tax',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">НДС, руб.</div>,
        },
        {
            accessorFn: (transaction) => (
                <div>
                    {toLocaleString(transaction.total)}
                </div>
            ),
            enableSorting: false,
            id: 'total',
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Итого оплачено, руб.</div>,
        },
        {
            accessorFn: (transaction) => (
                <div>
                    {transaction.storeName ?? "—"}
                </div>
            ),
            id: 'storeName',
            cell: info => info.getValue(),
            enableSorting: false,
            header: () => <div className="!text-start text-nowrap">Название ТСП</div>,
        },
        {
            accessorFn: (transaction) => (
                <div>
                    **** {transaction.cardNumber}
                </div>
            ),
            id: 'cardNumber',
            cell: info => info.getValue(),
            enableSorting: false,
            header: () => <div className="!text-start text-nowrap">Номер карты</div>,
        },
        // {
        //     accessorFn: (transaction) => (
        //         <div className="w-full flex justify-end gap-2">
        //             <ActionButton
        //                 onClick={() => navigate(`/partner/transactions/${transaction.id}`)}
        //                 icon={ArrowLeftSvg}
        //             />
        //         </div>
        //     ),
        //     id: 'actions',
        //     enableSorting: false,
        //     cell: info => info.getValue(),
        //     header: () => <div/>,
        // },
    ]

    return (
        <>
            {Boolean(transactions.length) && (
                <div className="table_box">
                    <Table columns={columns} data={transactions} />
                </div>
            )}
            {(!Boolean(transactions.length) && isLoading) && (
                <div className="info_panel">
                    <Loader />
                </div>
            )}
            {(!Boolean(transactions.length) && !isLoading) && (
                <NoTableData label="Не удалось найти транзакции"/>
            )}
        </>
    )
}

